import { useStore } from '~/store';

export default defineNuxtPlugin({
  name: 'intercom-plugin',
  enforce: 'pre',
  hooks: {
    'app:mounted': function () {
      // Загружаем только при взаимодействии пользователя
      let intercomLoaded = false;

      const loadIntercom = async () => {
        if (intercomLoaded) {
          return;
        }
        intercomLoaded = true;

        const store = useStore();
        const { default: Intercom } = await import('@intercom/messenger-js-sdk');

        Intercom({
          app_id: 'jijl2xhy',
          ...(store.user
            ? {
                avatar: store.user.avatar_url,
                user_id: store.user.steamid64,
                name: store.user.persona_name,
              }
            : {}),
          horizontal_padding: 150,
          vertical_padding: 55,
        });
      };

      // Загружаем при первом скролле или клике
      const events = ['scroll', 'click', 'keydown', 'touchstart'];
      const removeListeners = () => {
        events.forEach((event) => {
          window.removeEventListener(event, loadIntercom);
        });
      };

      events.forEach((event) => {
        window.addEventListener(event, async () => {
          await loadIntercom();
          removeListeners();
        }, { once: true, passive: true });
      });

      // Автозагрузка через 5 секунд
      setTimeout(async () => {
        await loadIntercom();
        removeListeners();
      }, 5000);
    },
  },
});
